import { createSelector } from 'reselect';
import creditsSelector from './currentCredits';

export default createSelector(creditsSelector, (credits) =>
    credits.find((credit) => credit.type === 'private_credits' && credit.remainingCredits > 0),
);
